import { render, staticRenderFns } from "./dateData.vue?vue&type=template&id=6853f884&scoped=true&"
import script from "./dateData.vue?vue&type=script&lang=js&"
export * from "./dateData.vue?vue&type=script&lang=js&"
import style0 from "./dateData.vue?vue&type=style&index=0&id=6853f884&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6853f884",
  null
  
)

export default component.exports